<button mat-raised-button (click)="openCamera()" class="full-width" [color]="cameraButtonColor">
  <mat-icon>{{ to?.icon || 'photo_camera' }}</mat-icon>
  {{ to?.label }}
</button>
